module.exports = __webpack_public_path__ + "static/media/burger.d6a65647.svg";